/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Proposals API
 * Moment's Proposals API allows Clients to manage optimization proposals.
 * OpenAPI spec version: 1.0.0
 */

/**
 * The maturity option for the ladder policy constraint.
 */
export type MaturityOption = typeof MaturityOption[keyof typeof MaturityOption];


export const MaturityOption = {
  maturity_date: 'maturity_date',
  workout_date: 'workout_date',
  next_call_date: 'next_call_date',
} as const;
